// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__35ZbR","options":"AnswerScale_options__3v4_k","selected":"AnswerScale_selected__10Kcf"};